import React from 'react';
import { NumeralDisplay } from '../../Fields';
import { NumericalReadOnlyViewProps } from '../types';

export const LoanToValueRatioReadOnlyView = (props: NumericalReadOnlyViewProps) => (
  <NumeralDisplay title="LVR" after="%" value={props.value} />
);
